module.exports = __webpack_public_path__ + "static/media/ciroc.7eb59209.png";